<div class="absolute inset-0 flex flex-col min-w-0 overflow-hidden">
    <div class="w-full max-w-screen-xl mx-auto" style="overflow-y: scroll;">
        <!--grid-->
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full min-w-0">
            <div class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                <div class="flex flex-col sm:flex-row items-start justify-between">
                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Cargas masivas
                    </div>
                    <button mat-flat-button color="accent" (click)="openDialogNuevaCarga();" *ngIf="configured">
                        <mat-icon svgIcon="heroicons_solid:plus"></mat-icon> Carga masiva
                    </button>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-1 grid-flow-row gap-6 w-full mt-8 sm:mt-4">
                    <div class="row">
                        <div class="col-12">
                            <app-grid-component
                                *ngIf="verGrid"
                                [datos]="objetoGridConfiguration?.Data"
                                [columns]="objetoGridConfiguration.Columns"
                                [exportExcel]="objetoGridConfiguration.ExportExcel"
                                [columnHiding]="objetoGridConfiguration.ColumnHiding"
                                [Checkbox]="objetoGridConfiguration.Checkbox"
                                [Editing]="objetoGridConfiguration.Editing"
                                [Columnchooser]="objetoGridConfiguration.Columnchooser"
                                [searchPanel]="objetoGridConfiguration.SearchPanel"
                                [scroll]="objetoGridConfiguration.Scroll"
                                (messageEvent)="receiveMessage($event)"
                                (datosevent)="datosMessage($event)"
                                [toolbar]="objetoGridConfiguration.ToolBox"
                                (onRowUpdated)="Actualizar($event)"
                                (modificar)='modificar($event.modificar.key)'
                                (eliminar)='eliminar($event.eliminar.key)'
                                [descargarExcel]="descargarExcel"
                                [nombreReporte]="nombreReporte"
                            ></app-grid-component>
                        </div>
                    </div>

                    <div class="row" *ngIf="!configured">
                        <div class="col-sm-12">
                            <div class="card p-4 mt-3" *ngIf="!configured">
                                <!-- Icon Section -->
                                <div class="d-flex justify-content-center align-items-center rounded-circle bg-primary text-white p-4 mb-4" style="width: 60px; height: 60px; margin: 0 auto;">
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="icon-size-10" style="width: 40px; height: 40px;">
                                        <path stroke-linecap="round" stroke-linejoin="round" d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z"></path>
                                    </svg>
                                </div>
                            
                                <!-- Title Section -->
                                <h5 class="card-title text-center">Emisor Requerido</h5>
                            
                                <!-- Description Section -->
                                <p class="card-text text-secondary text-center">
                                    Aún no tienes un emisor configurado. Por favor, crea uno para habilitar el acceso a esta sección.
                                </p>
                            
                                <!-- Button Section -->
                                <div class="text-center mt-4">
                                    <a routerLink="/cuenta/nonecompany" class="btn btn-primary">Crear emisor</a>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
